module.exports = __webpack_public_path__ + "img/halal.212dd98a.svg";